import { Grid } from '@mui/material';

import { capacitorService } from '../../../../application/CapacitorService';
import AppleBadge from '../../../../assets/img/store-badges/apple_US.svg';
import GoogleBadge from '../../../../assets/img/store-badges/google_US.png';
import Button from '../../../../react-components/Button';
import { AccountDeletionSlide } from './AccountDeletionSlide';

interface AccountDeletionWithSubscriptionDialogProps {
  onClose: () => void;
}

export const AccountDeletionWithSubscriptionDialog = ({ onClose }: AccountDeletionWithSubscriptionDialogProps) => {
  const isNative = capacitorService.isNative();
  const isAndroid = capacitorService.isAndroid();

  const titleId = `drivers.account_deletion_with_subscription_dialog.title`;
  const subtitleId = !isNative
    ? `drivers.account_deletion_with_subscription_dialog_web.subtitle`
    : `drivers.account_deletion_with_subscription_dialog.subtitle`;

  const openSubscriptionManagement = async () => {
    if (isAndroid) {
      window.location.href = `https://play.google.com/store/account/subscriptions`;
    } else {
      window.location.href = `https://apps.apple.com/account/subscriptions`;
    }
  };

  return (
    <AccountDeletionSlide
      children={
        isNative ? (
          <Grid style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column` }}>
            <Button
              style={{
                width: `100%`,
              }}
              onClick={() => openSubscriptionManagement()}
              intlId="drivers.account_deletion_with_subscription_dialog.view_subscriptions"
            />
          </Grid>
        ) : (
          <Grid style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column` }}>
            {isAndroid ? (
              <Grid
                item
                style={{
                  width: `100%`,
                  borderRadius: `10px`,
                  display: `flex`,
                  justifyContent: `center`,
                }}
                onClick={() =>
                  (window.location.href = `https://play.google.com/store/apps/details?id=com.routal.drivers`)
                }
              >
                <img src={GoogleBadge} style={{ height: `52px` }} alt="Get it on Google Play" />
              </Grid>
            ) : (
              <Grid
                item
                style={{
                  width: `100%`,
                  borderRadius: `10px`,
                  display: `flex`,
                  justifyContent: `center`,
                }}
                onClick={() => (window.location.href = `https://apps.apple.com/us/app/routal/id1581440136`)}
              >
                <img src={AppleBadge} style={{ height: `52px` }} alt="Download on the App Store" />
              </Grid>
            )}
          </Grid>
        )
      }
      onClose={onClose}
      openSlide={true}
      titleId={titleId}
      subtitleId={subtitleId}
    />
  );
};
